import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "$2890 May sidehustle report",
  "description": "",
  "published": "2017-06-06T00:00:00.000Z",
  "redirect_from": ["/blog/2890-may-sidehustle-report/swizec/7626"],
  "categories": "Business, Side Projects",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`May flew by in a blur. One day it was April, and the next it was June.`}</p>
    <p>{`Whooosh like a deadline!`}</p>
    <p>{`Most of the month went towards building a React Native Music App: `}<a parentName="p" {...{
        "href": "https://school.shoutem.com/lectures/build-react-native-music-app-tutorial-part1/"
      }}>{`Part 1`}</a>{` and `}<a parentName="p" {...{
        "href": "https://school.shoutem.com/lectures/react-native-soundcloud-streaming-app-tutorial-part-2/"
      }}>{`Part 2`}</a>{`. Subscribers on the React Native School project still aren't growing as fast as I'd like. Gonna have to figure something out.`}</p>
    <p>{`I think a combination of viral loops and better signup forms is necessary. The articles are long, so I don't think most people even scroll down to the form.`}</p>
    <p>{`Another big portion of the month went towards completing `}<a parentName="p" {...{
        "href": "https://gum.co/mTWg"
      }}>{`React + D3v4`}</a>{`. IT IS FUNCTIONALLY COMPLETE `}{`\\`}{`o/`}</p>
    <p>{`What remains is to test drive it, turn it into a course, polish the intro and outro texts, make a new landing page, update the offerings, spruce up some ads, update the email crash course, write an email launch sequence. Stuff like that.`}</p>
    <p>{`Y'know, the hard stuff, now that the fun stuff is done :)`}</p>
    <p>{`This focus on not-published-on-swizec.com content meant there was less traffic, which resulted in lower sales. As you can read in the numbers below.`}</p>
    <p>{`Might also be time to organize another workshop. Those always boost my numbers when they sell well.`}</p>
    <p>{`So… 👇`}</p>
    <p><strong parentName="p">{`Net hourly rate before tax:`}</strong>{` $14/hour`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/06/starbucks-salary.png",
        "alt": null
      }}></img></p>
    <p>{`I am officially better off doing this than working a second job at Starbucks. Life goals 💪🏼`}</p>
    <p><strong parentName="p">{`Total revenue:`}</strong>{` $2890`}</p>
    <p><strong parentName="p">{`Gumroad sales:`}</strong>{` $1084`}</p>
    <ul>
      <li parentName="ul">{`React D3v4 preorders: $539 -fees`}</li>
      <li parentName="ul">{`React D3js ES6: $712 - fees`}</li>
      <li parentName="ul">{`ES6 Cheatsheet: $21 - fees`}</li>
    </ul>
    <p>{`That's $188 in Gumroad fees 🤔 Perhaps it's time to explore Stripe and building my own integrations.`}</p>
    <p><strong parentName="p">{`Leanpub sales:`}</strong>{` $361`}</p>
    <ul>
      <li parentName="ul">{`Why Programmers Work at Night: $13`}</li>
      <li parentName="ul">{`React+D3: $26`}</li>
      <li parentName="ul">{`React D3js ES6: $322`}</li>
    </ul>
    <p><strong parentName="p">{`React Native School:`}</strong>{` $1445`}</p>
    <p><strong parentName="p">{`Time investment:`}</strong>{` 73 hours`}</p>
    <p><strong parentName="p">{`Expenses:`}</strong>{` $1872`}</p>
    <ul>
      <li parentName="ul">{`Editor: $400`}</li>
      <li parentName="ul">{`VA: $262`}</li>
      <li parentName="ul">{`Ads: $331`}</li>
      <li parentName="ul">{`Drip: $184`}</li>
      <li parentName="ul">{`Hosting: $10`}</li>
      <li parentName="ul">{`LiveEdu account: $10`}</li>
      <li parentName="ul">{`SumoMe: $99`}</li>
      <li parentName="ul">{`Mailchimp: $20`}</li>
      <li parentName="ul">{`Tech: $492`}</li>
      <li parentName="ul">{`Domains: $64`}</li>
      <li parentName="ul">{`[`}{`expense?] Seth Godin marketing course: $345`}</li>
    </ul>
    <p>{`I'm a little worried that I can't remember what those $492 in tech expenses were. There was one video game; inspiration and relaxation, totally serious business expense. And a new carry-on suitcase because I got a discount. Super necessary.`}</p>
    <p>{`But what was the other $200… I need to take better notes.`}</p>
    <p>{`On the bright side, swizec.com is securely mine for another 5 years. That was def worth the price.`}</p>
    <p>{`Does a marketing course count as an expense? Pretty sure Starbucks wouldn't pay for that if I was a barista, but my sidehustle did because my sidehustle values me as a gentleman and a scholar.`}</p>
    <p>{`🤔`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      